import { Component, OnInit } from '@angular/core';
import {
  IsiClientReportDetail, ISICountryWiseEntity,
  ISICountryWisePerson,
  IsiPersonReportDetail,
  ISIstructureWiseEntity
} from '../isi-report-detail/isi-report-detail.model';
import {ReportsService} from '../reports.service';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-isi-report-detail-two',
  templateUrl: './isi-report-detail-two.component.html',
  styleUrls: ['./isi-report-detail-two.component.css'],
  providers: [ReportsService]
})
export class IsiReportDetailTwoComponent implements OnInit {

  public allClient = new IsiClientReportDetail;
  public lowRiskBasedDV = new IsiClientReportDetail;
  public mediumRiskBasedDV = new IsiClientReportDetail;
  public highRiskBasedDV = new IsiClientReportDetail;
  public clientAtYearStart = new IsiClientReportDetail;
  public offBoardedClients = new IsiClientReportDetail;
  public newClientsAtYear = new IsiClientReportDetail;
  public clientAtYearEnd = new IsiClientReportDetail;
  public clientFromNetherland = new IsiClientReportDetail;
  public clientNotFromNetherland = new IsiClientReportDetail;
  public uboFromNetherland = new IsiPersonReportDetail;
  public uboNotFromNetherland = new IsiPersonReportDetail;
  uboPeps = new IsiPersonReportDetail;
  privateStructure = new IsiClientReportDetail;
  bfiClient = new IsiClientReportDetail;

  fiveLayersClient = new IsiClientReportDetail;
  dVWithNomineeShareholders = new ISIstructureWiseEntity;
  dvWithTrustOfficeAsNomineeShareholder = new IsiClientReportDetail;
  dvWithCVOrAlike = new ISIstructureWiseEntity;
  cvOrAlike = new ISIstructureWiseEntity;
  dvAsCoop = new IsiClientReportDetail;
  dvWithTrust = new ISIstructureWiseEntity;
  dvWithStichting = new ISIstructureWiseEntity;
  dvAsStichting = new IsiClientReportDetail;
  dVBuitendirecteuren = new IsiClientReportDetail;
  getClientWithRealEstate = new IsiClientReportDetail;
  dVWithManagementServices = new IsiClientReportDetail;
  dVWithDomiciliePlus = new IsiClientReportDetail;
  dVWithActAsTrusteeService = new IsiClientReportDetail;
  countryWisePEP = new ISICountryWisePerson;
  countryWiseUBO = new ISICountryWisePerson;
  countryWiseDVs = new ISICountryWiseEntity;

  constructor(private reportService: ReportsService,
              private route: ActivatedRoute) { }

  private getClientForISI(year, functionName, obj: IsiClientReportDetail) {
    this.reportService.getClientForISIReport(functionName, year)
      .subscribe(clients => {
        obj.clients = clients.arrResult;
        obj.isLoading = false;
      });
  }

  getCountryWiseEntity(year, functionName, obj: ISICountryWiseEntity) {
    this.reportService.getCountryWiseEntityForISIReport(functionName, year)
      .subscribe(response => {
        obj.data = response.arrResult;
        obj.isLoading = false;
      });
  }

  getPersonForISI(year, functionName, obj: IsiPersonReportDetail) {
    this.reportService.getPersonForISIReport(functionName, year)
      .subscribe(persons => {
        obj.person = persons.arrResult;
        obj.isLoading = false;
      });
  }

  getCountryWisePerson(year, functionName, obj: ISICountryWisePerson) {
    this.reportService.getCountryWisePersonForISIReport(functionName, year)
      .subscribe(persons => {
        obj.data = persons.arrResult;
        obj.isLoading = false;
      });
  }

  getStructureWiseEntity(year, functionName, obj: ISIstructureWiseEntity) {
    this.reportService.getStructureWiseEntityForISIReport(functionName, year)
      .subscribe(response => {
        obj.data = response.arrResult;
        obj.isLoading = false;
      });
  }

  private loadIsiQuestion(year) {
    this.allClient.isLoading = true;
    this.getClientForISI(year, 'getAllClients', this.allClient);
    this.lowRiskBasedDV.isLoading = true;
    this.getClientForISI(year, 'getLowRiskBasedDV', this.lowRiskBasedDV);
    this.mediumRiskBasedDV.isLoading = true;
    this.getClientForISI(year, 'getMediumRiskBasedDV', this.mediumRiskBasedDV);
    this.highRiskBasedDV.isLoading = true;
    this.getClientForISI(year, 'getHighRiskBasedDV', this.highRiskBasedDV);
    this.clientAtYearStart.isLoading = true;
    this.getClientForISI(year, 'clientsAtStartYear', this.clientAtYearStart);
    this.offBoardedClients.isLoading = true;
    this.getClientForISI(year, 'offboardedClients', this.offBoardedClients);
    this.newClientsAtYear.isLoading = true;
    this.getClientForISI(year, 'newClientsAtYear', this.newClientsAtYear);
    this.clientAtYearEnd.isLoading = true;
    this.getClientForISI(year, 'clientsAtEndYear', this.clientAtYearEnd);
    this.clientFromNetherland.isLoading = true;
    this.getClientForISI(year, 'getClientFromNetherlands', this.clientFromNetherland);
    this.clientNotFromNetherland.isLoading = true;
    this.getClientForISI(year, 'getClientNotFromNetherlands', this.clientNotFromNetherland);
    this.uboFromNetherland.isLoading = true;
    this.getPersonForISI(year, 'getUBOFromNL', this.uboFromNetherland);
    this.uboNotFromNetherland.isLoading = true;
    this.getPersonForISI(year, 'getUBONotFromNL', this.uboNotFromNetherland);
    this.uboPeps.isLoading = true;
    this.getPersonForISI(year, 'getPEPUBO', this.uboPeps);
    this.privateStructure.isLoading = true;
    this.getClientForISI(year, 'getPrivateStructure', this.privateStructure);
    this.bfiClient.isLoading = true;
    this.getClientForISI(year, 'getBFIClient', this.bfiClient);
    this.fiveLayersClient.isLoading = true;
    this.getClientForISI(year, 'getDVWithMoreThanFiveLayers', this.fiveLayersClient);
    this.dVWithNomineeShareholders.isLoading = true;
    this.getStructureWiseEntity(year, 'getDVWithNomineeShareholders', this.dVWithNomineeShareholders);
    this.dvWithTrustOfficeAsNomineeShareholder.isLoading = true;
    this.getClientForISI(year, 'getDVWithTrustOfficeAsNomineeShareholder', this.dvWithTrustOfficeAsNomineeShareholder);
    this.dvWithCVOrAlike.isLoading = true;
    this.getStructureWiseEntity(year, 'getDVWithCVOrAlike', this.dvWithCVOrAlike);
    this.cvOrAlike.isLoading = true;
    this.getStructureWiseEntity(year, 'getCVOrAlike', this.cvOrAlike);
    this.dvAsCoop.isLoading = true;
    this.getClientForISI(year, 'getDVAsCoop', this.dvAsCoop);
    this.dvWithTrust.isLoading = true;
    this.getStructureWiseEntity(year, 'getDVWithTrusts', this.dvWithTrust);
    this.dvWithStichting.isLoading = true;
    this.getStructureWiseEntity(year, 'getDVWithStichting', this.dvWithStichting);
    this.dvAsStichting.isLoading = true;
    this.getClientForISI(year, 'getDVAsStichting', this.dvAsStichting);
    this.dVBuitendirecteuren.isLoading = true;
    this.getClientForISI(year, 'getDVBuitendirecteuren', this.dVBuitendirecteuren);
    this.getClientWithRealEstate.isLoading = true;
    this.getClientForISI(year, 'getClientWithRealEstate', this.getClientWithRealEstate);
    this.dVWithManagementServices.isLoading = true;
    this.getClientForISI(year, 'getDVWithManagementServices', this.dVWithManagementServices);
    this.dVWithDomiciliePlus.isLoading = true;
    this.getClientForISI(year, 'getDVWithDomiciliePlus', this.dVWithDomiciliePlus);
    this.dVWithActAsTrusteeService.isLoading = true;
    this.getClientForISI(year, 'getDVWithActAsTrusteeService', this.dVWithActAsTrusteeService);
    this.countryWiseUBO.isLoading = true;
    this.getCountryWisePerson(year, 'UBOs', this.countryWiseUBO);
    this.countryWisePEP.isLoading = true;
    this.getCountryWisePerson(year, 'peps', this.countryWisePEP);
    this.countryWiseDVs.isLoading = true;
    this.getCountryWiseEntity(year, 'address', this.countryWiseDVs);
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      console.log(params);
      if (params['year']) {
        this.loadIsiQuestion(params['year']);
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/reports/isi-report-detail-two/isi-report-detail-two.component.ts